import { render, staticRenderFns } from "./SettingTable.vue?vue&type=template&id=361542df&scoped=true"
import script from "./SettingTable.vue?vue&type=script&lang=js"
export * from "./SettingTable.vue?vue&type=script&lang=js"
import style0 from "./SettingTable.vue?vue&type=style&index=0&id=361542df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361542df",
  null
  
)

export default component.exports